import { render, staticRenderFns } from "./AccountClass.vue?vue&type=template&id=0032cbdd"
import script from "./AccountClass.vue?vue&type=script&lang=js"
export * from "./AccountClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports